// Vendor imports
const PropTypes = require('prop-types')
const React = require('react')

class WindowResizeListener extends React.PureComponent {
  constructor(props) {
    super(props)

    this.onAnimationFrame = this.onAnimationFrame.bind(this)
    this.onResize = this.onResize.bind(this)
  }

  componentDidMount() {
    if (typeof window === 'object') {
      window.addEventListener('resize', this.onResize)
    }
  }

  componentWillUnmount() {
    if (typeof window === 'object') {
      window.removeEventListener('resize', this.onResize)
      this.clearTimeout()
      this.cancelAnimationFrame()
    }
  }

  onResize() {
    this.cancelAnimationFrame()
    if (this.props.animate) {
      this.requestAnimationFrame()
    }
    this.clearTimeout()
    if (typeof this.props.timeout === 'number') {
      this.setTimeout()
    } else {
      this.props.onResize()
    }
  }

  onAnimationFrame() {
    this.props.onResize()
    this.requestAnimationFrame()
  }

  requestAnimationFrame() {
    if (typeof window === 'object' && typeof requestAnimationFrame === 'function') {
      this._animationID = window.requestAnimationFrame(this.onAnimationFrame)
    }
  }

  cancelAnimationFrame() {
    if (this._animationID) {
      window.cancelAnimationFrame(this._animationID)
      delete this._animationID
    }
  }

  setTimeout() {
    this._timeoutID = setTimeout(() => {
      this.props.onResize()
      this.cancelAnimationFrame()
      this.clearTimeout()
    }, this.props.timeout)
  }

  clearTimeout() {
    if (this._timeoutID) {
      clearTimeout(this._timeoutID)
      delete this._timeoutID
    }
  }

  render() {
    return null
  }
}

WindowResizeListener.propTypes = {
  animate: PropTypes.bool,
  timeout: PropTypes.number,
  onResize: PropTypes.func.isRequired
}

module.exports = WindowResizeListener
